import {useAccount, useMsal} from '@azure/msal-react';
import EditIcon from '@mui/icons-material/Edit';
import {Box, MenuList, Popover, Typography} from '@mui/material';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import type * as React from 'react';
import {useState} from 'react';
import UserAvatar from '@/components/UserAvatar';
import type {BookmarkLink} from '@/context/PreferencesProvider';
import {usePreferencesState} from '@/context/PreferencesProvider';

type Props = {
    menuItems ?: Array<{
        title : string;
        callback : () => void;
    }>;
};

const UserMenu : React.FC<Props> = ({menuItems} : Props) => {
    const {instance, accounts} = useMsal();
    const account = useAccount(accounts[0] || null);
    const {linkGroups} = usePreferencesState().preferences.dashboard;
    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    // const [bookmarksDialogOpen, setBookmarksDialogOpen] = useState(false);
    // const modeState = useModeState();

    const handleMenuClose = () => {
        setAnchor(null);
    };

    const favorites = linkGroups.reduce(
        (favorites : BookmarkLink[], linkGroup) => [
            ...favorites,
            ...linkGroup.links.filter(link => link.favorite),
        ],
        []
    );

    return (
        <>
            <IconButton
                edge="end"
                onClick={event => {
                    setAnchor(event.currentTarget);
                }}
            >
                {account && <UserAvatar account={account}/>}
            </IconButton>

            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
            >
                <Box
                    sx={{
                        p: 1,
                    }}
                >
                    {account && <Box sx={{p: 2}}>
                        <Typography>
                            {account.name}
                            {' '}
                            <IconButton
                                size="small"
                                onClick={() => window.open('https://delve.office.com/?v=editprofile')}
                            >
                                <EditIcon fontSize="small"/>
                            </IconButton>
                        </Typography>
                        <Typography variant="body2" color="textSecondary">{account.username}</Typography>
                    </Box>}

                    {/*<Divider/>*/}

                    <MenuList>
                        {menuItems && (
                            menuItems.map((menuItem, index) => (
                                <MenuItem key={index} onClick={() => {
                                    handleMenuClose();
                                    menuItem.callback();
                                }}>{menuItem.title}</MenuItem>
                            ))
                        )}

                        {/*<MenuItem onClick={() => {*/}
                        {/*    handleMenuClose();*/}
                        {/*    setBookmarksDialogOpen(true);*/}
                        {/*}}>Bookmarks</MenuItem>*/}
                    </MenuList>

                    <Divider/>

                    {favorites.length > 0 && (
                        <>
                            <MenuList>
                                {favorites.map((link, index) => (
                                    <MenuItem key={index} onClick={() => {
                                        handleMenuClose();
                                        link.openInNew ? window.open(link.url) : window.location.href = link.url;
                                    }}>
                                        {link.title}
                                    </MenuItem>
                                ))}
                            </MenuList>

                            <Divider/>
                        </>
                    )}

                    {/*<MenuList>*/}
                    {/*    <MenuItem>*/}
                    {/*        <FormControlLabel*/}
                    {/*            control={<Switch*/}
                    {/*                checked={modeState.mode === 'dark'}*/}
                    {/*                onChange={event => modeState.setMode(event.target.checked ? 'dark' : 'light')}*/}
                    {/*            />}*/}
                    {/*            label="Dark mode"*/}
                    {/*        />*/}
                    {/*    </MenuItem>*/}
                    {/*</MenuList>*/}

                    <Divider/>

                    <MenuList>
                        <MenuItem onClick={async () => {
                            await instance.logoutRedirect();
                            // msal.logout();
                        }}>Sign out</MenuItem>
                    </MenuList>

                    {/*<BookmarksDialog open={bookmarksDialogOpen} onClose={() => {*/}
                    {/*    setBookmarksDialogOpen(false);*/}
                    {/*}}/>*/}
                </Box>
            </Popover>
        </>
    );
};

export default UserMenu;
